import React, { useState } from 'react'; 
import GetSelectMonths from '../../Dropdowns/getSelectMonth';
import GetSelectYears from '../../Dropdowns/getSelectYear';
import GetCommodities from '../../Dropdowns/getCommodities';
import Stock_District from './Stock_District';
const Stock_Interface = ({ heading }) => {

    const [renderContent, setRenderContent] = useState(null);
    const [loading, setLoading] = useState(true);  

    const handleLoadingChange = (isLoading) => {
       setLoading(isLoading);
   };

        const handleSubmit = () => {
        const month = document.getElementById('month').value;
        const year = document.getElementById('year').value; 
        const comm_id = document.getElementById('comm_id').value; 
 
        if (month==0 || month == null || month ==''  ) { 
            alert('Please select  Month');
        } else  if (year==0 || year == null || year ==''  ) {
            alert('Please select  Year');
        }  else  if (comm_id==0 || comm_id == null || comm_id ==''  ) {
            alert('Please select Commodity');
        }  else {
            setRenderContent(null);

            setTimeout(() => {
                setRenderContent(
                    <Stock_District 
                        month={month} 
                        year={year}
                        comm_id={comm_id} 
                        heading={heading} 
                    />
                );
            }, 0);
                }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="30%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={10}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Month</td>
                                    <td><GetSelectMonths input_id = {"month"} onLoadingChange={handleLoadingChange} /></td>
                                    <td> Year</td>
                                    <td><GetSelectYears input_id = 'year' onLoadingChange={handleLoadingChange} /></td>
 
                                  <td>Commodity</td>
                                    <td><GetCommodities /></td>
                                </tr>
                                <tr>
                                    <td colSpan={10} align="center">
                                    <button onClick={handleSubmit} className="button button2" disabled={loading}>
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    {/* Render the dynamic content here */}
                    <div id="detailsER">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default Stock_Interface;
